/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Summary of kills done by the given corporation against enemy factions
 * @export
 * @interface GetCorporationsCorporationIdFwStatsKills
 */
export interface GetCorporationsCorporationIdFwStatsKills {
    /**
     * Last week's total number of kills by members of the given corporation against enemy factions
     * @type {number}
     * @memberof GetCorporationsCorporationIdFwStatsKills
     */
    lastWeek: number;
    /**
     * Total number of kills by members of the given corporation against enemy factions since the corporation enlisted
     * @type {number}
     * @memberof GetCorporationsCorporationIdFwStatsKills
     */
    total: number;
    /**
     * Yesterday's total number of kills by members of the given corporation against enemy factions
     * @type {number}
     * @memberof GetCorporationsCorporationIdFwStatsKills
     */
    yesterday: number;
}

/**
 * Check if a given object implements the GetCorporationsCorporationIdFwStatsKills interface.
 */
export function instanceOfGetCorporationsCorporationIdFwStatsKills(value: object): value is GetCorporationsCorporationIdFwStatsKills {
    if (!('lastWeek' in value) || value['lastWeek'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('yesterday' in value) || value['yesterday'] === undefined) return false;
    return true;
}

export function GetCorporationsCorporationIdFwStatsKillsFromJSON(json: any): GetCorporationsCorporationIdFwStatsKills {
    return GetCorporationsCorporationIdFwStatsKillsFromJSONTyped(json, false);
}

export function GetCorporationsCorporationIdFwStatsKillsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCorporationsCorporationIdFwStatsKills {
    if (json == null) {
        return json;
    }
    return {
        
        'lastWeek': json['last_week'],
        'total': json['total'],
        'yesterday': json['yesterday'],
    };
}

export function GetCorporationsCorporationIdFwStatsKillsToJSON(json: any): GetCorporationsCorporationIdFwStatsKills {
    return GetCorporationsCorporationIdFwStatsKillsToJSONTyped(json, false);
}

export function GetCorporationsCorporationIdFwStatsKillsToJSONTyped(value?: GetCorporationsCorporationIdFwStatsKills | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'last_week': value['lastWeek'],
        'total': value['total'],
        'yesterday': value['yesterday'],
    };
}

